import React, { useState, useEffect, useContext } from "react";
import { UserContext } from "../../service/context";
import ApproveTransfer from "./ApproveTransfer";
import ApproveExtend from "./ApproveExtend";
import ApproveSendToAdmin from "./ApproveSendToAdmin";
import moment from "moment/moment";
import { socket } from "../../service/socket";
import swal from "@sweetalert/with-react";
import CustomeModal from "../../component/modal-popup/customeModal";
import NewRequestTable from "./NewRequestTable";
import OldRequestTable from "./OldRequestTable";

// Redux
import { useDispatch, useSelector } from "react-redux";
import {
  getNewRequestData,
  acceptExtension,
  acceptTransfer,
  acceptBackToAdmin,
  rejectRequest,
} from "../../redux/actions/request";
import { getUserData } from "../../redux/actions/user";
function RequestOverview() {
  /* ---------------------- Default Access Token and Company ID ---------------------- */
  const ctx = useContext(UserContext);
  /* ---------------------------------------------------------------------------------- */

  const [requestId, setRequestId] = useState(null);
  const [requestedTime, setRequestedTime] = useState(null);
  const [activityAssignmentMappingID, setActivityAssignmentMappingID] =
    useState(null);
  const [reasonByUser, setReasonByUser] = useState(null);
  const [updateTable, setUpdateTable] = useState(0);
  const [openTab, setOpenTab] = useState(1);

  // State for modal pop-up
  const [openTransferModal, setOpenTransferModal] = useState(false);
  const [openExtendModal, setOpenExtendModal] = useState(false);
  const [openSendToAdminModal, setOpenSendToAdminModal] = useState(false);

  const [width, setWidth] = useState(window.innerWidth);

  const windowResize = () => {
    setWidth(window.innerWidth);
  };

  useEffect(() => {
    window.addEventListener("resize", windowResize);
  }, [window.innerWidth]);

  // Using redux hook
  const dispatch = useDispatch();

  const handleTransferAccept = async (id) => {
    const request = {
      id,
      onSuccess: () => {
        setOpenTransferModal(!openTransferModal);
        setRequestId(null);
        setUpdateTable(updateTable + 1);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Transfer To Do request accepted successfully.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      onError: () => {
        setOpenTransferModal(!openTransferModal);
        setRequestId(null);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(acceptTransfer(request));
  };

  const handleAcceptExtension = async (allowance, id) => {
    const request = {
      onSuccess: () => {
        setOpenExtendModal(!openExtendModal);
        setRequestId(null);
        setUpdateTable(updateTable + 1);
        setReasonByUser(null);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Extend To Do request accepted successfully.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        socket.emit("request_pending_count", {
          email: ctx.user.email,
          company_id: ctx.user.company.id,
        });
      },
      onError: () => {
        setOpenExtendModal(!openExtendModal);
        setRequestId(null);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
      allowance,
      id,
    };
    dispatch(acceptExtension(request));
  };

  const handleAcceptBackToAdmin = async (user_id, mappingId, reqId) => {
    if (!user_id) {
      return swal({
        content: (
          <CustomeModal
            type="error"
            title="Error!"
            content={`Please select user to accept request.`}
          />
        ),
        buttons: false,
        closeOnClickOutside: false,
        closeOnEsc: false,
      });
    }
    const request = {
      reqId,
      user_id: user_id.value,
      user_email: null,
      activity_assignment_mapping_id: mappingId,
      onSuccess: () => {
        setOpenSendToAdminModal(!openSendToAdminModal);
        setReasonByUser(null);
        setUpdateTable(updateTable + 1);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`To Do transfered to another user successfully.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        socket.emit("request_pending_count", {
          email: ctx.user.email,
          company_id: ctx.user.company.id,
        });
      },
      onError: () => {
        setOpenSendToAdminModal(!openSendToAdminModal);
        setReasonByUser(null);
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(acceptBackToAdmin(request));
  };

  const handleRejectRequest = async (id) => {
    const request = {
      id,
      onSuccess: () => {
        setUpdateTable(updateTable + 1);
        swal({
          content: (
            <CustomeModal
              type="success"
              title="Success!"
              content={`Request rejected successfully.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
        socket.emit("request_pending_count", {
          email: ctx.user.email,
          company_id: ctx.user.company.id,
        });
      },
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`Something went wrong. Please try again later.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(rejectRequest(request));
  };

  const handleGetUser = () => {
    const request = {
      onError: () => {
        swal({
          content: (
            <CustomeModal
              type="error"
              title="Error!"
              content={`User does not found.`}
            />
          ),
          buttons: false,
          closeOnClickOutside: false,
          closeOnEsc: false,
        });
      },
    };
    dispatch(getUserData(request));
  };

  useEffect(() => {
    if (openSendToAdminModal) {
      handleGetUser();
    }
  }, [openSendToAdminModal]);

  const handleAcceptClick = (requestType) => {
    if (requestType === "Transfer To Do") {
      setOpenTransferModal(!openTransferModal);
    } else if (requestType === "Extend To Do") {
      setOpenExtendModal(!openExtendModal);
    } else if (requestType === "Back to Admin") {
      setOpenSendToAdminModal(!openSendToAdminModal);
    }
  };

  return (
    <div className="mt-4 sm:mx-6 lg:mx-8">
      <header className="">
        <ul
          className="relative text-sm font-medium flex flex-nowrap overflow-x-scroll no-scrollbar "
          id="tabs-tabJustify"
          role="tablist"
        >
          <li className="flex-grow sm:flex-grow-0 text-center">
            <a
              href="#tabAdded"
              className={
                "w-full block font-medium leading-5 whitespace-nowrap text-xs sm:text-sm border-x-0 border-t-0 border-b-2 px-6 py-4 my-3" +
                (openTab === 1
                  ? "border-b-2 border-[--bg-color-500] text-black"
                  : null)
              }
              id="tab-added"
              data-toggle="tab"
              role="tablist"
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(1);
              }}
            >
              New Requests
            </a>
          </li>
          <li className="nav-item flex-grow sm:flex-grow-0 text-center">
            <a
              href="#tabNotadded"
              className={
                "w-full block font-medium leading-5 whitespace-nowrap text-xs sm:text-sm border-x-0 border-b-2 border-t-0 px-6 py-4 my-3" +
                (openTab === 2
                  ? "border-b-2 border-[--bg-color-500] text-black"
                  : null)
              }
              id="tab-added"
              data-toggle="tab"
              role="tablist"
              onClick={(e) => {
                e.preventDefault();
                setOpenTab(2);
              }}
            >
              Old Requests
            </a>
          </li>
        </ul>
      </header>
      <section>
        <div
          className={`${
            openTab === 1 ? "block" : "hidden"
          } overflow-x-auto my-2`}
        >
          <NewRequestTable
            updateTable={updateTable}
            handleRejectRequest={handleRejectRequest}
            setRequestId={setRequestId}
            setRequestedTime={setRequestedTime}
            handleAcceptClick={handleAcceptClick}
            setActivityAssignmentMappingID={setActivityAssignmentMappingID}
            setReasonByUser={setReasonByUser}
          />
        </div>
        <div
          className={`${
            openTab === 2 ? "block" : "hidden"
          } overflow-x-auto my-2`}
        >
          <OldRequestTable />
        </div>
      </section>

      <ApproveTransfer
        openTransferModal={openTransferModal}
        setOpenTransferModal={setOpenTransferModal}
        handleAccept={handleTransferAccept}
        id={requestId}
      />

      <ApproveExtend
        openExtendModal={openExtendModal}
        setOpenExtendModal={setOpenExtendModal}
        reqTime={requestedTime}
        handleAccept={handleAcceptExtension}
        id={requestId}
        reason={reasonByUser}
      />

      <ApproveSendToAdmin
        openSendToAdminModal={openSendToAdminModal}
        setOpenSendToAdminModal={setOpenSendToAdminModal}
        handleAccept={handleAcceptBackToAdmin}
        mappingId={activityAssignmentMappingID}
        reason={reasonByUser}
        id={requestId}
      />
    </div>
  );
}

RequestOverview.auth = { path: "/requests/overview", role: "super-admin admin" };
export default RequestOverview;
